import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const SocialMediaMarketing = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          // Give the line a CSS gradient based on scroll position
          progress = 3000 - progress * 1.6;
    
          // Update the SVG element with the new stroke-dashoffset
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);
    
        // Remove the event listener when the component unmounts
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, // Ensures the animation occurs only once
        threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/dedicated-dev-2.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                    <h1 id="heading_line">The Ultimate Guide to Content Marketing: Strategies for Success and Long-Term Growth</h1>
                    <h2 id="sub_heading1">
                    In today’s fast-paced digital world, businesses need a strong content marketing strategy to stand out, engage their audience, and drive conversions. Content marketing is not just about creating content but about delivering value to your audience. Whether you are a small business owner or a seasoned marketer, understanding the importance of effective content marketing can help you build trust, enhance your online presence, and achieve your marketing goals.
                    </h2>                                    
                </div>
              </div>
            </div>
            </div>
            <div className="why_coustom_app">
                <div className="wrapper">
                <h3>What is <span>Content Marketing ?</span> </h3>
                    <p>Content marketing involves creating and distributing valuable, relevant, and consistent content to attract and engage a clearly defined audience. Unlike traditional advertising, content marketing focuses on building relationships with customers rather than pushing products or services. By providing helpful information, entertainment, or insights, you can position your brand as a thought leader in your industry.</p>

                    <h3>Why is Content <span>Marketing Important?</span></h3>
                    <h4>1.	Drives Organic Traffic</h4>
                    <p>Content marketing helps your website rank higher on search engines like Google. By optimizing your blog posts, articles, and web pages with the right keywords, you can improve your SEO and increase organic traffic. The more high-quality content you produce, the more opportunities there are for your audience to find you online.</p>
                    <h4>2.	Builds Brand Authority and Trust</h4>
                    <p>Consistent, valuable content helps you establish your brand as a trusted resource. When customers see that you provide valuable insights, they are more likely to return for more and eventually make a purchase.</p>
                    <h4>3.	Increases Engagement and Retention</h4>
                    <p>Content marketing allows you to engage your audience on multiple platforms (social media, email, blogs, etc.). This constant interaction helps keep your brand top-of-mind, improving customer retention.</p>
                    <h4>4.	Generates Leads</h4>
                    <p> By offering useful content (like eBooks, case studies, webinars, or guides), you can gather customer data and generate leads. Content marketing is an effective tool for lead nurturing and conversion.</p>
                    <h3>Types of Content <span>Marketing</span></h3>
                    <h4>1.	Blog Posts and Articles</h4>
                    <p> Blogging remains one of the most effective content marketing tools. Regular blog posts allow you to provide valuable information and improve your SEO. Keyword optimization, such as using phrases like “best content marketing strategies,” “increase website traffic,” and “content marketing ROI,” can attract the right audience to your site.</p>
                    <h4>2.	Video Marketing</h4>
                    <p>Videos are highly engaging and shareable. Platforms like YouTube, Instagram, and TikTok are great for video content. Video marketing helps build emotional connections with your audience and can communicate complex ideas quickly.</p>
                    <h4>3.	Infographics</h4>
                    <p>Infographics simplify complex information and make it more digestible. By using visual aids, you can increase engagement and shareability of your content.</p>
                    <h4>4.	Social Media Posts</h4>
                    <p> Social media allows businesses to engage with their audience directly. Regular posts, stories, polls, and live sessions can increase brand visibility and interaction.</p>
                    <h4>5.	Email Newsletters</h4>
                    <p>Email remains a highly effective tool for content marketing. By providing exclusive content, updates, and special offers via email, you can keep your audience engaged and informed.</p>
                    <h3>Tips for Effective Content <span>Marketing</span></h3>
                    <h4>Tips for Effective Content </h4>
                    <p>To create content that resonates, you need to understand who your target audience is. Create buyer personas and tailor your content to their needs, interests, and pain points.</p>
                    <h4>2.	Focus on Quality Over Quantity</h4>
                    <p>While consistency is important, the quality of your content matters more. Focus on providing real value with every piece of content you create. Always ensure your content is well-researched, engaging, and informative.</p>
                    <h4>3.	Leverage SEO</h4>
                    <p> To maximize the impact of your content, focus on SEO. Use keyword research tools to identify relevant keywords for your industry. Optimize your headlines, meta descriptions, and content to rank higher on search engines.</p>
                    <h4>4.	Use Content Distribution Channels</h4>
                    <p>Don’t just create content and hope for the best. Promote your content through various channels—social media, email, partnerships, and guest posts. The more you distribute your content, the more exposure your brand gets.</p>
                    <h4>5.	Measure and Optimize</h4>
                    <p>Content marketing isn’t a one-and-done strategy. Continuously measure the performance of your content using metrics like traffic, engagement, conversion rates, and ROI. Use these insights to refine and improve your strategy over time.</p>
                    <h3><span>Conclusion</span></h3>
                    <p>Content marketing is a powerful tool that can help businesses of all sizes grow and thrive. By producing valuable content that resonates with your target audience, you can drive organic traffic, build brand trust, and convert leads into loyal customers. Remember, successful content marketing is about consistency, creativity, and optimization. Start crafting your content strategy today and watch your brand soar to new heights!</p>
                </div>
            </div>
            <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
            </div>
            <div className="let_build">
                <div className="wrapper">
                <h4>Let’s Build <span> Your App Together </span></h4>
                
                <p>
                Whether you’re a startup looking to disrupt the market or an
                established enterprise aiming to enhance operational efficiency,
                CodeFlix is here to bring your vision to life. Let’s create a
                custom mobile app that drives results and delights your users.{" "}
                <br />
                Contact Us today to get started on your mobile app development
                journey.
                </p>
                </div>
            </div>
        </>
      );
};
export default SocialMediaMarketing;
